import EditVM from './edit-vm';

export default function(data) {
  var self = this;

  self.forums = ko.observableArray([]);
  self.course = ko.observable();
  self.threads = ko.observableArray([]);
  self.fullLoading = ko.observable(true);
  self.selectedForum = ko.observable(null);
  self.selectedSort = ko.observable('order');
  self.searchQuery = ko.observable(null);
  self.totalThreadCount = ko.observable(0);
  self.viewAllCount = ko.observable(0);
  self.firstLoad = ko.observable(true);
  self.parent_id = ko.observable(null);
  self.parent = ko.observable(null);
  self.stateChanged = ko.observable(false);

  self.selectedForum = ko.observable(null);

  let newForumVM = null;

  self.bindData = function(data) {
    var mapping = {
      create: function(options) {
        if(!options.data.course_id)
          options.data.course_id = data.course.id;

        var forumVM = new EditVM(options.data, self);

        self.forumAddRemovedListener(forumVM);

        return forumVM;
      }
    };

    self.forums = ko.mapping.fromJS(data.forums, mapping);
    self.course = ko.mapping.fromJS(data.course);
    self.viewAllCount(data.view_all_count);
    self.selectedSort.subscribe(self.updateSorting);
    self.parent_id(data.parent_id);
    self.parent(data.parent);
  };

  self.initUI = function() {};

  self.manageSubforum = function(forum_id) {
    Kadenze.Request.pjax({
      url: Kadenze.Routes.manage_course_forums_path(self.course.slug(), {forum_id: forum_id})
    });
  };

  self.forumCssClass = function(item) {
    var cls = item ? item.css_class() : '';
    if (item && item.subforums().length) {
      cls += ' has-subforums';
    }
    return cls;
  };

  // Helpers
  self.firstLetter = function(word) {
    return word().substr(0, 1);
  };

  self.editForum = function(data){
    var allowedForums = _.filter(self.forums(), function(f) {
      return f.forum().subforum_required() || f.forum().subforums().length;
    });

    data.availableForums(allowedForums);
    data.courseId(self.course.id());

    self.selectedForum(data);

    if (data.forum().private())
      data.loadUsers();
  };

  self.initDraggable = () => {
    $('#forum-card-list').sortable({
      items: '.forum-list-preview',
      handle: '.kd-data-table__sort-handle',
      helper: function (e, ui) {
        ui.children().each(() => $(this).width($(this).width()));
        return ui;
      },
      update: (e, ui) => {
        self.updateRowOrder();
      },
    });
  };

  self.updateRowOrder = () => {
    let data, updatedOrder;
    self.orderList = _.map(self.forums, function(n) { return n.toString(); });
    updatedOrder = [...new Set([...$('#forum-card-list').sortable('toArray'), ...self.orderList])]
      .map(forum_id => forum_id.split('-')[1]);

    data = { 'forums': updatedOrder }
    let request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.sort_course_forums_path(self.course.id()),
      type: 'POST',
      data: data,
      dataAsJSON: false,
      dataType: 'text',
      loadingIndicator: {
        container: '#main-container'
      }
    });

    request.done((response, textStatus, xhr) => {
      new Kadenze.Notice.success({ message: response.message });
    });

    request.fail((xhr, textStatus, errorThrown) => {
      $('#forum-card-list').sortable('cancel');
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
    });
  };

  self.initializeNewForum = function() {
    var allowedForums = _.filter(self.forums(), function(f) {
      return f.forum().subforum_required() || f.forum().subforums().length;
    });

    var data = {
      course_id: self.course.id(),
      forums: allowedForums,
      parent_id: self.parent_id(),
      parent: self.parent(),
      title: '',
      description: '',
      options: {
        subforum_required: false
      },
      private: false,
      title_editable: true,
      user_ids: []
    };

    newForumVM = new EditVM(data, self);

    newForumVM.saved.subscribe(function(newVal) {
      if (newVal == true) {
        var forum = newForumVM.forum();

        if ( forum.parent_id() == self.parent_id())
          self.forums.push(newForumVM);
      }
    });

    self.forumAddRemovedListener(newForumVM);

    self.selectedForum(newForumVM);
  };

  self.forumAddRemovedListener = function($forumVM) {
    $forumVM.removed.subscribe(function(newVal) {
      if (newVal == true) {
        if ( $forumVM.forum().parent_id() == self.parent_id())
          self.forums.remove($forumVM);
      }
    });
  };

  const __construct = function (that) {
    console.log('constructor called for ForumManageListingViewModel');
    that.bindData(data);
    that.initializeNewForum();
    that.initUI();
    that.initDraggable();
  }(this);
}
